<div *ngIf="displayBothDates || !timeZoneService.displayTripTimezone || !tripTimezoneTime" class="timeZoneDate" [class._alignRight]="alignRight">
    <i class="fa-fw fa fa-user" *ngIf="displayLogo"></i>
    <div>{{defaultTimezoneTime}}</div>
</div>
<div *ngIf="displayBothDates || (tripTimezoneTime && timeZoneService.displayTripTimezone)" class="timeZoneDate" [class._alignRight]="alignRight">
    <i class="fa-fw fa fa-route" *ngIf="displayLogo"></i>
    <div *ngIf="tripTimezoneTime">{{tripTimezoneTime}}</div>
    <div *ngIf="!tripTimezoneTime"[i18n]="'time.no-local-time'"></div>
</div>
